module.exports = global["Player"] = require("-!/player/node_modules/babel-loader/lib/index.js!/player/node_modules/string-replace-webpack-plugin/loader.js?id=62mx62fgxlu!./player.js");


//////////////////
// WEBPACK FOOTER
// ./src/player.js
// module id = RQgh
// module chunks = 0